import React, { useState, useEffect } from "react";
import { Table, Input, Spinner } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { useSelector } from "react-redux";
import axios from "axios";

const EnquiryIndex = () => {
    const { AuthReducer: { auth } } = useSelector((state) => state);
    const [enquiries, setEnquiries] = useState([]);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState('desc');
    const [paginate, setPaginate] = useState(10);
    const [loading, setLoading] = useState(false);
    const [enquiryCount, setEnquiryCount] = useState(0);

    const fetchEnquiries = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/admin/v1/enquiries?limit=${paginate}&page=${page}&search=${search}&sort=${sort}`,
                { headers: { Authorization: `Bearer ${auth?.token}` } }
            );
            setEnquiries(res.data.EnquiryLists || []);
            setEnquiryCount(res.data.enquiryCount || 0);
        } catch (err) {
            setEnquiries([]);
            setEnquiryCount(0);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (auth?.token) fetchEnquiries();
        // eslint-disable-next-line
    }, [auth?.token, paginate, page, search, sort]);
    console.log(enquiries);
    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <div className="mb-4 d-flex align-items-center justify-content-between" >
                        <h5 className="mb-0 text-white fs-4">Enquiry List</h5>
                    </div>
                </div>
            </div>
            <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>
                <div className="row">
                    <div className="col-md-3 mb-2">
                        <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
                    </div>
                    <div className="col-md-2 offset-md-7 mb-2">
                        <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                        </Input>
                    </div>
                    <div className="col-md-12">
                        <Table hover responsive>
                            <thead>
                                <tr>
                                    <th>SL. No.</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan="5"><Spinner /></td></tr>
                                ) : enquiries.length === 0 ? (
                                    <tr>
                                        <td colSpan="5">No data found</td>
                                    </tr>
                                ) : (
                                    enquiries.map((item, index) => (
                                        <tr key={item.id}>
                                            <th scope="row">{index + 1 + page * paginate}</th>
                                            <td>{item.name}</td>
                                            <td>{item.email}</td>
                                            <td>{item.mobile}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-6 d-flex">
                        <div className="col-md-2">
                            <Input
                                type="select"
                                id="paginate"
                                onChange={e => setPaginate(Number(e.target.value))}
                                value={paginate}
                                className="paging custom-select custom-select-page m-0"
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </Input>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <Pagination
                            pageCount={Math.ceil(enquiryCount / paginate)}
                            onChange={(e) => setPage(e.selected)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnquiryIndex; 